import { createSelector, createSlice, nanoid } from "@reduxjs/toolkit";
import { SHAPE_TYPES } from "../../utils";

export const counterSlice = createSlice({
  name: "@editor",
  initialState: {
    value: 0,
    selected: {},
    project: {
      title: "Untitled Project",
      id: nanoid(),
      background: "#ff4081",
      layers: [
        {
          ff: "Karla",
          fs: 17,
          c: "#000",
          x: 0,
          y: 0,
          o: 1,
          type: SHAPE_TYPES.TEXT_ELEMENT,
          text: "Hello",
          id: nanoid(),
        },
        {
          url: "https://konvajs.org//assets/darth-vader.jpg",
          type: SHAPE_TYPES.IMAGE_ELEMENT,
          id: nanoid(),
          x: 0,
          y: 0,
        },
      ],
    },
  },
  reducers: {
    increment: (state) => {
      // Redux Toolkit allows us to write "mutating" logic in reducers. It
      // doesn't actually mutate the state because it uses the Immer library,
      // which detects changes to a "draft state" and produces a brand new
      // immutable state based off those changes
      state.value += 1;
    },
    decrement: (state) => {
      state.value -= 1;
    },
    incrementByAmount: (state, action) => {
      state.value += action.payload;
    },
    selectLayer(state, action) {
      state.selected = action.payload;
    },
    batchUpdateLayer(state, action) {
      let layer = state.project.layers.find(
        (layer) => layer.id === state.selected.id
      );
      layer = { ...layer, ...action.payload };
      state.selected = { ...state.selected, ...action.payload };
    },
  },
});

export const {
  increment,
  decrement,
  incrementByAmount,
  batchUpdateLayer,
  selectLayer,
} = counterSlice.actions;

// The function below is called a thunk and allows us to perform async logic. It
// can be dispatched like a regular action: `dispatch(incrementAsync(10))`. This
// will call the thunk with the `dispatch` function as the first argument. Async
// code can then be executed and other actions can be dispatched
export const incrementAsync = (amount) => (dispatch) => {
  setTimeout(() => {
    dispatch(incrementByAmount(amount));
  }, 1000);
};

// The function below is called a selector and allows us to select a value from
// the state. Selectors can also be defined inline where they're used instead of
// in the slice file. For example: `useSelector((state) => state.counter.value)`
export const selectCount = (state) => state.counter.value;
export const selectProject = (state) => state.counter.project;
export const selectLayers = createSelector(
  selectProject,
  (project) => project.layers
);

export default counterSlice.reducer;
